var map = {
	"./de-AT.json": 6296,
	"./de-CH.json": 2274,
	"./de-DE.json": 5006,
	"./de.json": 5894,
	"./en-US.json": 5381,
	"./en.json": 4174,
	"./nl-NL.json": 348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4649;